/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatePlatformFeedbackDto } from '../models/CreatePlatformFeedbackDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ClientAppPlatformFeedbackService {
    /**
     * Submit platform feedback
     *
     * Allows an authenticated client to submit a rating and optional feedback
     * about their experience with the JFIT platform.
     *
     * **Validations:**
     * - Rating must be between 1 and 5
     * - Feedback text is optional
     *
     * @param requestBody
     * @returns any Feedback submitted successfully
     * @throws ApiError
     */
    public static platformFeedbackControllerSubmitFeedbackV1(
        requestBody: CreatePlatformFeedbackDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/client-app/platform-feedback',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
            },
        });
    }
}
